import styled from 'styled-components';

export const SyncStartedToastWrapper = styled.div`
`;
